module.exports = __webpack_public_path__ + "gear-icon.e0302235a3ec4efcbb3c.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/gear-icon.svg
// module id = ../../../../../src/img/icon/gear-icon.svg
// module chunks = styles